import 'babel-polyfill';
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { combineReducers } from 'redux'
import './index.css'
import AppContainer from './AppContainer'
import configureStore from './configureStore'
import registerServiceWorker from './registerServiceWorker'
import * as reducers from './reducers'
import { initializeIcons } from '@uifabric/icons'
import { initializeData } from '@chegg-wt/redux-citation-api'

initializeIcons(/* optional base url */)

const store = configureStore(combineReducers(reducers))

window.Office.initialize = () => {
  store.dispatch(initializeData())
}

ReactDOM.render(
  <Provider store={store}><AppContainer /></Provider>
  , document.getElementById('root'))




// WEBPACK FOOTER //
// ./src/index.js